import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { isDev } from "lib/useful";

const packageJSON = require("../package.json");
console.log(
  "CertSystem client v" + packageJSON.version + (isDev() ? "dev" : ""),
);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);
